// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Constant imports
import { URLConstants } from '../../_constants/url-constants';

// Model imports
import { UserCommunitiesParametersDto } from '../_models/user-communities/user-communities-parameters-dto';
import { UserCommunitiesResultDto } from '../_models/user-communities/user-communities-result-dto';
import { UserCommunityCoordinatesResultDto } from '../_models/user-communities/user-community-coordinates-result-dto';
import { UpdateUserCommunityCoordinatesParametersDto } from '../_models/user-communities/update-user-community-coordinates-parameters-dto';

@Injectable({
    providedIn: 'root'
})
export class UserCommunitiesService {
    constructor(private readonly httpClient: HttpClient) {}

    getUserCommunities(params: UserCommunitiesParametersDto): Observable<UserCommunitiesResultDto[]> {
        const url = `${URLConstants.ccUserBaseApiUrl}/my/communities`;
        return this.httpClient
            .post(url, classToPlain(params))
            .pipe(map((response: any[]) => plainToClass(UserCommunitiesResultDto, response)));
    }

    getUserCommunitiesMap(params: UserCommunitiesParametersDto): Observable<UserCommunityCoordinatesResultDto[]> {
        const url = `${URLConstants.ccUserBaseApiUrl}/my/communities/map`;
        return this.httpClient
            .post(url, classToPlain(params))
            .pipe(map((response: any[]) => plainToClass(UserCommunityCoordinatesResultDto, response)));
    }

    getCommunityServices(serviceUrl: string): Observable<string[]> {
        return this.httpClient.get<string[]>(serviceUrl);
    }

    updateUserCommunityCoordinates(params: UpdateUserCommunityCoordinatesParametersDto): Observable<any> {
        const url = `${URLConstants.ccUserBaseApiUrl}/my/community/latlong`;
        return this.httpClient.put(url, classToPlain(params));
    }
}
